/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sch_Err_Workflow_In_Use_OneInputs */

const en_sch_err_workflow_in_use_one = /** @type {(inputs: Sch_Err_Workflow_In_Use_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 product uses this workflow. Switch it to another workflow first.`)
};

const de_sch_err_workflow_in_use_one = /** @type {(inputs: Sch_Err_Workflow_In_Use_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 Produkt nutzt diesen Workflow. Stelle es zuerst auf einen anderen Workflow um.`)
};

/**
* | output |
* | --- |
* | "1 product uses this workflow. Switch it to another workflow first." |
*
* @param {Sch_Err_Workflow_In_Use_OneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sch_err_workflow_in_use_one = /** @type {((inputs?: Sch_Err_Workflow_In_Use_OneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sch_Err_Workflow_In_Use_OneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_sch_err_workflow_in_use_one(inputs)
	return en_sch_err_workflow_in_use_one(inputs)
});